import { motion } from 'framer-motion';

const MapleLeafSvg = ({ className, style }) => (
  <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor">
    <path d="M50 97 L50 60 M50 60 C45 55 30 58 25 50 C30 50 35 45 35 40 C25 42 15 38 10 30 C20 32 25 28 30 22 C25 20 22 12 25 5 C32 12 40 15 50 10 C60 15 68 12 75 5 C78 12 75 20 70 22 C75 28 80 32 90 30 C85 38 75 42 65 40 C65 45 70 50 75 50 C70 58 55 55 50 60"/>
  </svg>
);

const leaves = [
  { id: 1, size: 50, left: '70%', delay: 0, duration: 14, color: '#1a5c1e' },
  { id: 2, size: 40, left: '80%', delay: 2, duration: 17, color: '#a6533a' },
  { id: 3, size: 46, left: '60%', delay: 4, duration: 13, color: '#2d5a2d' },
  { id: 4, size: 36, left: '85%', delay: 1, duration: 18, color: '#8b6b4a' },
  { id: 5, size: 55, left: '55%', delay: 3, duration: 15, color: '#1a5c1e' },
  { id: 6, size: 42, left: '75%', delay: 6, duration: 16, color: '#6b5344' },
  { id: 7, size: 34, left: '65%', delay: 5, duration: 14, color: '#a6533a' },
];

export const FallingMapleLeaves = () => (
  <div className="absolute inset-0 z-[2] overflow-hidden pointer-events-none">
    {leaves.map((leaf) => (
      <motion.div
        key={leaf.id}
        className="absolute"
        style={{ left: leaf.left, top: -50 }}
        initial={{ y: -50, rotate: 0, opacity: 0 }}
        animate={{
          y: ['0vh', '110vh'],
          rotate: [0, 360, 180, 360],
          opacity: [0, 0.45, 0.45, 0]
        }}
        transition={{ duration: leaf.duration, delay: leaf.delay, repeat: Infinity, ease: "linear" }}
      >
        <motion.div
          animate={{ x: [0, -30, 15, -20, 0], rotateY: [0, 180, 360] }}
          transition={{ duration: leaf.duration / 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <MapleLeafSvg className="drop-shadow-sm" style={{ width: leaf.size, height: leaf.size, color: leaf.color }} />
        </motion.div>
      </motion.div>
    ))}
  </div>
);
